import { render, staticRenderFns } from "./institutionalIncomeDetail.vue?vue&type=template&id=1e9c4735&scoped=true&"
import script from "./institutionalIncomeDetail.vue?vue&type=script&lang=js&"
export * from "./institutionalIncomeDetail.vue?vue&type=script&lang=js&"
import style0 from "./institutionalIncomeDetail.vue?vue&type=style&index=0&id=1e9c4735&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9c4735",
  null
  
)

export default component.exports